module.exports = __webpack_public_path__ + "img/logo_ru.ec9f0935.png";